"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_focus_lock_1 = require("react-focus-lock");
require("./confirmation.less");
function Confirmation(props) {
    var secondaryContent = null;
    if (props.secondaryMessage) {
        secondaryContent = typeof (props.secondaryMessage) === "string" ? React.createElement("div", { className: "multiline-text-ellipsis" },
            React.createElement("p", { className: "secondary-content" }, props.secondaryMessage)) : React.createElement("div", { className: "secondary-content" }, props.secondaryMessage);
    }
    var noButton = props.noCaption
        ? React.createElement("button", { className: "pure-button pure-button-transparent", onClick: props.onCancel }, props.noCaption)
        : null;
    return React.createElement(React.Fragment, null,
        React.createElement(react_focus_lock_1.default, { returnFocus: true },
            React.createElement("div", { className: "confirmation-box" + (props.typeClassName ? " " + props.typeClassName : ""), style: { position: "relative", display: "block" } },
                React.createElement("h3", null, props.title),
                React.createElement("div", { className: "primary-content" },
                    React.createElement("p", { role: "alertdialog", className: "l-box-vb" }, props.message),
                    secondaryContent),
                React.createElement("div", { className: "action-buttons" },
                    noButton,
                    React.createElement("button", { className: "pure-button pure-button-primary", onClick: props.onConfirm, autoFocus: true }, props.yesCaption)))));
}
exports.Confirmation = Confirmation;
function mergeWithDefaultOptions(options) {
    var defaultOptions = null;
    switch (options.type) {
        case "default":
            defaultOptions = options;
            break;
        case "delete":
            defaultOptions = getDeleteConfirmationDefaultOptions(options);
            break;
        case "undo":
            defaultOptions = getUndoConfirmationDefaultOptions(options);
            break;
        case "cancel":
            defaultOptions = getCancelConfirmationDefaultOptions(options);
            break;
        case "warning":
            defaultOptions = getWarningConfirmationDefaultOptions(options);
            break;
    }
    return {
        typeClassName: options.typeClassName !== undefined ? options.typeClassName : (defaultOptions ? defaultOptions.typeClassName : undefined),
        title: options.title !== undefined ? options.title : (defaultOptions ? defaultOptions.title : undefined),
        message: options.message !== undefined ? options.message : (defaultOptions ? defaultOptions.message : undefined),
        secondaryMessage: options.secondaryMessage !== undefined ? options.secondaryMessage : (defaultOptions ? defaultOptions.secondaryMessage : undefined),
        yesCaption: options.yesCaption !== undefined ? options.yesCaption : (defaultOptions ? defaultOptions.yesCaption : undefined),
        noCaption: options.noCaption !== undefined ? options.noCaption : (defaultOptions ? defaultOptions.noCaption : undefined)
    };
}
exports.mergeWithDefaultOptions = mergeWithDefaultOptions;
function getDeleteConfirmationDefaultOptions(options) {
    var recordName = options.recordName || "";
    var titleRecordName = !recordName ? "" : Pb.TextHelper.sentenceCase(recordName);
    var messageRecordName = !recordName ? "" : (" " + recordName.toLowerCase());
    var verb = options.verb || "Delete";
    var titleVerb = Pb.TextHelper.sentenceCase(verb);
    var messageVerb = verb.toLowerCase();
    return {
        typeClassName: "confirm-delete-box",
        title: titleVerb + (titleRecordName ? " " + titleRecordName : "") + "?",
        message: "Are you sure you want to " + messageVerb + " this" + messageRecordName + "?",
        yesCaption: titleVerb + (titleRecordName ? " " + titleRecordName : ""),
        noCaption: "Cancel"
    };
}
function getUndoConfirmationDefaultOptions(options) {
    return {
        typeClassName: "confirm-undo-changes-box",
        title: "Undo Changes?",
        message: "Are you sure you want to undo your changes?",
        yesCaption: "Undo",
        noCaption: "Cancel"
    };
}
function getCancelConfirmationDefaultOptions(options) {
    return {
        typeClassName: "cancel-confirmation-box",
        title: "Cancel Changes?",
        message: "Are you sure you want to cancel your changes?",
        yesCaption: "Cancel Changes",
        noCaption: "Keep Changes"
    };
}
function getWarningConfirmationDefaultOptions(options) {
    return {
        typeClassName: "warning-confirmation-box",
        title: options.title || "Warning",
        message: options.message,
        yesCaption: options.yesCaption,
        noCaption: options.noCaption
    };
}
